import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01b1dc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blue" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"template\" data-v-01b1dc6c><h5 data-v-01b1dc6c>STATISTICS FROM MY 2+ YEARS OF CONSULTING</h5><div class=\"grid-container\" data-v-01b1dc6c><div class=\"column centerall\" data-v-01b1dc6c><h6 class=\"fgray ra\" data-v-01b1dc6c>HELPED</h6><h3 class=\"flightergray pxh\" data-v-01b1dc6c>11</h3><h6 class=\"fgray\" data-v-01b1dc6c>CLIENTS</h6></div><div class=\"column centerall\" data-v-01b1dc6c><h6 class=\"fgray ra\" data-v-01b1dc6c>BUILT</h6><h3 class=\"flightergray pxh\" data-v-01b1dc6c>5</h3><h6 class=\"fgray\" data-v-01b1dc6c>APPS</h6></div><div class=\"column centerall\" data-v-01b1dc6c><h6 class=\"fgray ra\" data-v-01b1dc6c>DESIGNED</h6><h3 class=\"flightergray pxh\" data-v-01b1dc6c>12</h3><h6 class=\"fgray\" data-v-01b1dc6c>WEBSITES</h6></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown, FadeLeft, FadeRight } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Stats',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})